import { Questionnaire } from './questionnaire';

export class PatientAssessment {
  memberId: string;
  assessment: Questionnaire;
  assignedDt: Date;
  dueDate: Date;
  assignedBy: string;
  status: string;
  orgid: number;
  orglevel: number;
  memberassessmentid: number;
  filledquestionnaireid: number;
}
export enum PatientAssessmentStatus {
  DRAFT = 'DRAFT',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  ATTEMPTED = 'ATTEMPTED',
  ASSIGNED = 'ASSIGNED',
  ARCHIVED = 'ARCHIVED'
}
